// extracted by mini-css-extract-plugin
export default {"tabs":"yXN9BpntO_"};
    if(module.hot) {
      // 1633091726536
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  